module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_03_6DD79_1SE_GBA.d11ec5fe.png";